/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vocabulary } from "../../Utils/Vocabulary";
import { CustomerModel, CustomerTypeModel } from "../../Utils/Models";
import { TextValidator } from "react-material-ui-form-validator";
import {
  Autocomplete,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { onChangeTextField } from "../../Utils/Utils";
import { useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { toast } from "react-toastify";
import { CountryType } from "./Address";
import { postData } from "../../Services/postData";
import { urlEnum } from "../../Utils/UrlEnum";
import { Add } from "@mui/icons-material";
import CustomerType from "./CustomerType";

type CustomerProps = {
  customer: CustomerModel;
  handleChangeCustomer: (product: CustomerModel) => void;
};
export default function Customer(props: CustomerProps) {
  const { customer, handleChangeCustomer } = props;
  const [countriesAndStates, setCountriesAndStates] = useState<
    Array<CountryType>
  >([]);
  const [cities, setCities] = useState<Array<string>>([]);
  const [customerTypes, setCustomerTypes] = useState<Array<CustomerTypeModel>>(
    new Array<CustomerTypeModel>()
  );
  const [openType, setOpenType] = useState(false);
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [anotherAddress, setAnotherAddress] = useState(false);

  useEffect(() => {
    //Fetch the countries and its states
    getData("https://countriesnow.space/api/v0.1/countries/states")
      .then((res) => {
        const data = Array.from(
          new Map(
            res.data.data.map((item: CountryType) => [item.name, item])
          ).values()
        );
        setCountriesAndStates(data as CountryType[]);
      })
      .catch((err) => {
        toast.error("Cannot get countries");
      });
  }, []);

  useEffect(() => {
    //Fetch the list for customer type
    //TODO need to add results to cache instead of calling each time
    const isCustomerType = !customer.isVendor && !(customer as any).isPartner;
    if (isCustomerType) {
      getData(`${urlEnum.customerCrm}/type`)
        .then((res) => {
          if (res.data.result.length > 0) {
            setCustomerTypes(res.data.result);
          }
        })
        .catch((err) => {
          toast.error("Cannot got types");
        });
      setShouldUpdate(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldUpdate]);

  useEffect(() => {
    if (customer.address.county) {
      postData(`https://countriesnow.space/api/v0.1/countries/state/cities`, {
        country: customer.address.country,
        state: customer.address.county,
      })
        .then((res) => {
          setCities(res.data.data);
        })
        .catch((error) => {
          toast.error("Cannot get cities");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer.address.county]);

  function AddButtonForAutocomplete({ children, fieldName, ...other }: any) {
    return (
      <Paper {...other}>
        <div style={{ position: "absolute", right: -30, top: -32 }}>
          <IconButton
            onMouseDown={(e) => {
              e.preventDefault();
              setOpenType(true);
            }}
            style={{
              background: "#18cc9c",
              color: "white",
              borderRadius: "50%",
              width: 20,
              height: 20,
              padding: 13,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <Add style={{ verticalAlign: "middle" }} />
          </IconButton>
        </div>
        {children}
      </Paper>
    );
  }

  const selectedCountry = countriesAndStates.find(
    (c: CountryType) => c.name === customer.address.country
  );
  const countyOptions = selectedCountry?.states || [];
  return (
    <>
      <Grid container spacing={2} style={{ marginTop: 10 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl>
            <FormLabel id="clientTypeGroupLabel">
              {Vocabulary.clientType}
            </FormLabel>
            <RadioGroup
              onChange={(event) => {
                handleChangeCustomer({
                  ...customer,
                  isLegalPerson:
                    event.target.value === Vocabulary.individual ? false : true,
                });
              }}
              value={customer.isLegalPerson}
              aria-labelledby="clientTypeGroupLabel"
            >
              <FormControlLabel
                checked={!customer.isLegalPerson}
                value={Vocabulary.individual}
                control={<Radio />}
                label={Vocabulary.individual}
              />
              <FormControlLabel
                checked={customer.isLegalPerson}
                value={Vocabulary.legalEntity}
                control={<Radio />}
                label={Vocabulary.legalEntity}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          {!customer.isLegalPerson ? (
            <TextValidator
              size="small"
              id="CNP"
              name="CNP"
              label={Vocabulary.pin}
              fullWidth
              variant="outlined"
              value={customer.CNP || ""}
              onChange={(event: any) =>
                handleChangeCustomer(onChangeTextField(event, customer))
              }
            />
          ) : (
            <TextValidator
              size="small"
              id="fiscalCode"
              name="fiscalCode"
              label={Vocabulary.fiscalCode}
              fullWidth
              variant="outlined"
              value={customer.fiscalCode || ""}
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              onChange={(event: any) =>
                handleChangeCustomer(onChangeTextField(event, customer))
              }
            />
          )}
        </Grid>
        {customer.isLegalPerson ? (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              id="companyName"
              name="companyName"
              label={Vocabulary.companyName}
              fullWidth
              variant="outlined"
              value={customer.companyName || ""}
              onChange={(event: any) =>
                handleChangeCustomer(onChangeTextField(event, customer))
              }
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              id="name"
              name="name"
              label={Vocabulary.name}
              fullWidth
              variant="outlined"
              value={customer.name}
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              onChange={(event: any) =>
                handleChangeCustomer(onChangeTextField(event, customer))
              }
            />
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            size="small"
            id="phone"
            name="phone"
            label={Vocabulary.phone}
            fullWidth
            variant="outlined"
            value={customer.phone}
            validators={!customer.isLegalPerson ? ["required"] : []}
            errorMessages={[Vocabulary.requiredField]}
            onChange={(event: any) =>
              handleChangeCustomer(onChangeTextField(event, customer))
            }
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            size="small"
            id="email"
            name="email"
            label={Vocabulary.email}
            fullWidth
            variant="outlined"
            value={customer.email}
            validators={[
              "isEmail",
              `${!customer.isLegalPerson ? "required" : ""}`,
            ]}
            errorMessages={[
              Vocabulary.requiredField,
              Vocabulary.emailValidation,
            ]}
            onChange={(event: any) =>
              handleChangeCustomer(onChangeTextField(event, customer))
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            size="small"
            id="tradeRegisterNo"
            name="tradeRegisterNo"
            label={Vocabulary.cui}
            fullWidth
            variant="outlined"
            value={customer.tradeRegisterNo || ""}
            onChange={(event: any) =>
              handleChangeCustomer(onChangeTextField(event, customer))
            }
          />
        </Grid>
        {!customer.isVendor && !(customer as any).isPartner && (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Autocomplete
              multiple
              size="small"
              id="type"
              freeSolo={true}
              options={customerTypes}
              value={customer.category}
              getOptionLabel={(option: any) => option.name}
              isOptionEqualToValue={(option: any, value: any) =>
                option === value
              }
              onChange={async (event, value: any) => {
                handleChangeCustomer({
                  ...customer,
                  category: value,
                });
              }}
              PaperComponent={({ children, ...other }) =>
                AddButtonForAutocomplete({
                  children,
                  fieldName: "type",
                  ...other,
                })
              }
              renderInput={(params: any) => (
                <TextValidator
                  {...params}
                  fullWidth
                  label={Vocabulary.category}
                  variant="outlined"
                  value={customer.category}
                />
              )}
            />
          </Grid>
        )}
        {!customer.isLegalPerson && (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Checkbox
              style={{ verticalAlign: "middle" }}
              onClick={(event: any) => {
                setAnotherAddress(!anotherAddress);
              }}
              checked={anotherAddress}
              color="primary"
            />
            {Vocabulary.anotherAddress}
          </Grid>
        )}
        {anotherAddress && (
          <>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span>{Vocabulary.invoiceAddress}</span>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Autocomplete
                size="small"
                id="type"
                freeSolo={true}
                options={countriesAndStates.map(
                  (country: CountryType) => country.name
                )}
                value={customer.address.country}
                getOptionLabel={(option: any) => option}
                isOptionEqualToValue={(option: any, value: any) =>
                  option === value
                }
                getOptionDisabled={(option: string) =>
                  option === customer.address.country
                }
                onChange={async (event, value: any) => {
                  handleChangeCustomer({
                    ...customer,
                    address: {
                      ...customer.address,
                      country: value,
                      county: "",
                      city: "",
                      details: "",
                      postcode: "",
                    },
                  });
                }}
                renderInput={(params: any) => (
                  <TextValidator
                    {...params}
                    fullWidth
                    label={Vocabulary.country}
                    variant="outlined"
                    value={customer.address.country}
                    validators={["required"]}
                    errorMessages={[Vocabulary.requiredField]}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Autocomplete
                size="small"
                id="type"
                freeSolo={true}
                options={countyOptions.map((state) => state.name)}
                disabled={customer.address.country === ""}
                value={customer.address.county}
                getOptionLabel={(option: any) => option}
                isOptionEqualToValue={(option: any, value: any) =>
                  option === value
                }
                getOptionDisabled={(option: string) =>
                  option === customer.address?.county
                }
                onChange={(event, value: any) => {
                  handleChangeCustomer({
                    ...customer,
                    address: {
                      ...customer.address,
                      county: value,
                      city: "",
                      postcode: "",
                    },
                  });
                }}
                renderInput={(params: any) => (
                  <TextValidator
                    {...params}
                    fullWidth
                    label={Vocabulary.county}
                    value={customer.address.county}
                    variant="outlined"
                    validators={["required"]}
                    errorMessages={[Vocabulary.requiredField]}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Autocomplete
                size="small"
                id="type"
                freeSolo={true}
                options={cities.map((state) => state)}
                disabled={customer.address.county === ""}
                value={customer.address.city}
                getOptionLabel={(option: any) => option}
                isOptionEqualToValue={(option: any, value: any) =>
                  option === value
                }
                getOptionDisabled={(option: string) =>
                  option === customer.address?.city
                }
                onChange={(event, value: any) => {
                  handleChangeCustomer({
                    ...customer,
                    address: {
                      ...customer.address,
                      city: value,
                      postcode: "",
                    },
                  });
                }}
                renderInput={(params: any) => (
                  <TextValidator
                    {...params}
                    fullWidth
                    label={Vocabulary.city}
                    value={customer.address.city}
                    variant="outlined"
                    validators={["required"]}
                    errorMessages={[Vocabulary.requiredField]}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextValidator
                size="small"
                id="details"
                name="details"
                label={Vocabulary.details}
                fullWidth
                variant="outlined"
                value={customer.address.details}
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
                onChange={(event: any, value: any) =>
                  handleChangeCustomer({
                    ...customer,
                    address: {
                      ...customer.address,
                      details: event.target.value,
                    },
                  })
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextValidator
                size="small"
                id="postcode"
                name="postcode"
                label={Vocabulary.zip}
                fullWidth
                variant="outlined"
                value={customer.address.postcode}
                onChange={(event: any, value: any) =>
                  handleChangeCustomer({
                    ...customer,
                    address: {
                      ...customer.address,
                      postcode: event.target.value,
                    },
                  })
                }
              />
            </Grid>
          </>
        )}
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <span>{Vocabulary.customerSettings}</span>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Checkbox
            style={{ verticalAlign: "middle" }}
            onClick={(event: any) => {
              if (customer.receiveEmails) {
                handleChangeCustomer({ ...customer, receiveEmails: false });
              } else {
                handleChangeCustomer({ ...customer, receiveEmails: true });
              }
            }}
            checked={customer.receiveEmails}
            color="primary"
          />
          {Vocabulary.clientEmailContact}
        </Grid>
      </Grid>
      {openType && (
        <>
          <CustomerType
            open={openType}
            shouldUpdate={false}
            onClose={() => {
              setOpenType(false);
              setShouldUpdate(true);
            }}
          />
        </>
      )}
    </>
  );
}
